export function getInjectedContentPagePermalink(pathname) {
  if (window.__PUCK_CONTENT_PAGE_PERMALINK__) {
    const permalink = window.__PUCK_CONTENT_PAGE_PERMALINK__;
    sessionStorage.setItem(
      "__PUCK_CONTENT_PAGE",
      JSON.stringify({ path: pathname, permalink })
    );
    delete window.__PUCK_CONTENT_PAGE_PERMALINK__;
    return permalink;
  }

  const stored = sessionStorage.getItem("__PUCK_CONTENT_PAGE");
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (parsed.path === pathname) {
        return parsed.permalink;
      }
    } catch (e) {
      console.warn("Invalid session value:", e);
    }
  }

  return null;
}
